import { Button } from '@pidedirecto/ui';
import { WhatsAppIcon } from '@pidedirecto/ui/icons';
import * as React from 'react';
import { Country } from 'src/constants/Country';
import { isPossiblePhoneNumber } from 'src/utils/is/isPossiblePhoneNumber';

export function OpenWhatsAppButton({ phoneNumber, disabled, message, country }: Props): React.ReactElement | null {
    function openWhatsappInAnotherPage(phoneNumber: string): void {
        window.open(`https://wa.me/${phoneNumber.toString()}?text=${message ?? ''}`);
    }

    if (!phoneNumber || !isPossiblePhoneNumber(phoneNumber, country)) return null;

    return (
        <Button variant='icon' onClick={() => openWhatsappInAnotherPage(phoneNumber)} disabled={disabled}>
            <WhatsAppIcon color={'#8d25ff'} />
        </Button>
    );
}

type Props = {
    phoneNumber: string;
    message?: string;
    disabled?: boolean;
    country?: Country;
};
